import { defaultWalletConnectChainRegistry } from './chainRegistry.js';
export const chainsToNetworkTypes = (chains, registry = defaultWalletConnectChainRegistry) => {
    const types = new Set();
    for (const chain of chains ?? []) {
        const networkType = registry.get(chain.split(':')[0])?.networkType;
        if (networkType)
            types.add(networkType);
    }
    return [...types];
};
